import React from 'react';
import {__} from '../../../../assets/javascripts/library.js';

function EfzStatusMessage({ efzStatus }) {
    if (efzStatus === 'NOT_CHECKED') {
        return <p style={{fontWeight: 'bold'}}>
            Dein erweitertes Führungszeugnis konnte nicht automatisch überprüft werden. Bitte kontaktiere die Aktionsleitung, da deine Teilnahme nur mit gültigem eFZ möglich ist.
        </p>;
    }

    if (efzStatus === 'CHECKED_INVALID') {
        return <p style={{fontWeight: 'bold'}}>
            Du hast noch kein erweitertes Führungszeugnis bereitgestellt, sodass deine Teilnahme nicht möglich ist. Bitte reiche dein erweitertes Führungszeugnis umgehend ein,
            da deine Teilnahme andernfalls storniert werden kann. Bitte setze dich mit der Aktionsleitung in Verbindung.
        </p>;
    }

    return null; // default: nix anzeigen
}

function SuccessContainer({ participant_data }) {
    return (
        <p>
            <h3>{__('Hello', 'solea')} {participant_data.nicename}</h3>
            <p>
                {participant_data.introduction}<br />
                {__('We have received the following information:', 'solea')}
            </p>
            <table className="solea-payment-table">
                <tr><td>{__('Arrival', 'solea')}:</td><td>{participant_data.arrival}</td></tr>
                <tr><td>{__('Departure', 'solea')}:</td><td>{participant_data.departure}</td></tr>
                <tr><td>{__('Participation group', 'solea')}:</td><td>{participant_data.participation_group}</td></tr>
            </table>
            
            <p>
            Du erhältst innerhalb der nächsten 2 Stunden eine Email mit deiner Anmeldebestätigung.<br /><br />
			Wenn du mit dem Auto anreist und Menschen mitnehmen kannst melde dich bitte in der VBT WhatsApp Gruppe.
            </p>
            
            <p>
            Weitere Informationen zur Veranstaltung erhältst du eine Woche vorher. Falls du in der Zwischenzeit Fragen hast melde dich in der VBT WhatsApp Gruppe oder bei Inja (inja@dpvonline.de)
            </p>
        </p>
        );
}

export default SuccessContainer;